import * as d3 from 'd3';
import * as $ from 'jquery';

import { ITreeItem } from '../../models';

class ModelQualityAnalysisChart {
    private _groupsGroup: d3.Selection<any>;
    private _datagroups: d3.Selection<any>;
    private _svg: d3.Selection<any>;
    private _columns: string[];
    private _margin = 10;
    private _rowHeight: number;
    private _colWidth: number;
    private _onClick: (d: ITreeItem) => void;

    private _formatter = d3.format('2.2%');
    constructor(container: any,
        columns: string[]) {
        this._columns = columns;
        let width = 400;
        const height = 40;
        try {
            const node = $('#chart').select();
            node.resize(() => {
                // this._svg.style('display', 'none')
                width = node.width();
                // this._svg.style('display', 'block');
                this.resize(width, node.height());
            });
        } catch (e) {
            console.error(e);
        }
        this._rowHeight = 30;

        this._colWidth = width / this._columns.length;
        this._svg = container.append('svg')
            .attr('width', width)
            .attr('height', height)
            .classed('table-svg', true);
        const subContainer = this._svg
            .append('g')
            .classed('model-quality', true);
        const headingRow = subContainer.append('g')
            .classed('heading', true);
        const headings = headingRow
            .selectAll('.col')
            .data(this._columns)
            .enter()
            .append('g')
            .classed('col', true)
            .attr('transform', (d, i) => `translate(${i * width / this._columns.length + this._margin},${0})`);
        headings.append('text')
            .attr('dy', '.35em')
            .attr('y', 12)
            .text(d => d);
        headingRow.append('line')
            .classed('separator', true)
            .attr('x1', 0)
            .attr('x2', width)
            .attr('y1', this._rowHeight)
            .attr('y2', this._rowHeight);
        this._groupsGroup = subContainer.append('g')
            .classed('groups', true)
            .attr('transform', (d, i) => `translate(${0},${this._rowHeight})`);
    }

    update(groups: any[]) {
        this._svg.attr('height', (groups.length + 1) * this._rowHeight);
        this.redraw(groups);
    }

    onClick(value: (d: ITreeItem) => void): this {
        this._onClick = value;
        return this;
    }

    private resize(width: number, height: number) {
        this._svg.attr('width', width);
        this._colWidth = width / this._columns.length;
        const scale = d3.scale.linear()
            .range([0, this._colWidth - 2 * this._margin])
            .domain([0, 1]);

        const headingRow = this._svg
            .select('g.model-quality')
            .select('.heading');
        headingRow.select('line')
            .attr('x2', width);
        headingRow
            .selectAll('.col')
            .transition()
            .attr('transform', (d, i) => `translate(${i * this._colWidth + this._margin},${0})`);
        const row = this._groupsGroup.selectAll('.row');
        row.select('line.separator')
            .attr('x2', width);
        const dataGroup = row
            .selectAll('.data')
            .transition()
            .attr('transform', (d, i) => `translate(${(i + 1) * this._colWidth},${0})`);
        dataGroup.select('g.rect-container')
            .select('rect.border')
            .transition()
            .attr('width', scale.range()[1]);

        dataGroup.selectAll('g.value')
            .select('rect')
            .transition()
            .attr('x', d => { return (!isNaN(d.start)) ? scale(d.start) : 0; })
            .attr('width', d => { return (!isNaN(d.value)) ? scale(d.value) : 0; });
    }


    private redraw(rows: { group: ITreeItem, data: any }[]) {
        const dataBound = this._groupsGroup.selectAll('.row')
            .data(rows);
        dataBound
            .exit()
            .remove();
        const enterSelection = dataBound
            .enter()
            .append('g')
            .classed('row', true)
            .attr('transform', (d, i) => `translate(${0},${i * this._rowHeight})`);
        enterSelection.append('line')
            .classed('separator', true)
            .attr('x1', 0)
            .attr('y1', this._rowHeight)
            .attr('y2', this._rowHeight);
        enterSelection
            .append('g')
            .classed('name', true)
            .classed('clickable', !!this._onClick)
            .append('text')
            .classed('group-name', true)
            .attr('y', this._rowHeight - this._margin)
            .attr('alignment-baseline', 'baseline')
            .on('click', d => {
                if (this._onClick) {
                    this._onClick(d as any);
                }
            });
        const cols = this._columns.slice(1, this._columns.length)
            .map(d => d.toLowerCase());
        const scale = d3.scale.linear()
            .range([0, this._colWidth - 2 * this._margin])
            .domain([0, 1]);
        const dataGroup = dataBound
            .selectAll('.data')
            .data<any>(d => d.data);
        const enterDataGroup = dataGroup
            .enter()
            .append('g')
            .classed('data', true)
            .attr('transform', (d, i) => `translate(${(i + 1) * this._colWidth},${0})`);
        dataGroup.style('cursor', d => d.redirect ? 'pointer' : null)
            .on('click', d => {
                if (d.redirect) {
                    d.redirect();
                }
            });
        const rectHeight = this._rowHeight - 2 * this._margin;
        const enterContainer = enterDataGroup.append('g')
            .classed('rect-container', true)
            .attr('transform', `translate(${this._margin},${this._margin})`);
        const rectBound = dataGroup.select('g.rect-container')
            .selectAll('g.value')
            .data<any>(d => {
                return d.data || [];
            });
        rectBound
            .exit()
            .remove();
        const enterSubSelection = rectBound
            .enter()
            .append('g')
            .classed('value', true);
        enterSubSelection.append('rect')
            .classed('value', true)
            .attr('height', rectHeight);
        enterSubSelection.append('title');
        rectBound
            .select('rect')
            .style('fill', d => d.color)
            .attr('x', d => { return (!isNaN(d.start)) ? scale(d.start) : 0; })
            .attr('width', d => { return (!isNaN(d.value)) ? scale(d.value) : 0; });
        rectBound.select('title')
            .text(d => `${d.name} - ${this._formatter(d.value)}`);
        // enterContainer
        //     .append('rect')
        //     .classed('border', true)
        //     .attr('height', rectHeight)
        //     .attr('width', scale.range()[1])
        //     .style('fill', 'transparent')
        //     .style('stroke', missingTextColor)
        //     .style('pointer-events', 'none');
        dataBound
            .select('.name')
            .attr('transform', (d, i) => `translate(${(d.group.depth - 1) * 15},${0})`)
            .select('.group-name')
            .text(d => (d.group as any).uniqueName);
    }
}

export default ModelQualityAnalysisChart;